import { GridHeaderWithTooltipComponent } from '../rankings/data-widgets/grid-header-with-tooltip.component';
import { DataOnlyComponent } from '../rankings/data-widgets/data-only.component';
import { YesnoComponent } from '../rankings/data-widgets/yesno.component';
import { RankDataComponent } from '../rankings/data-widgets/rank-data.component';
import { SdkNameComponent } from '../rankings/data-widgets/sdk-name.component';
import { BigNumberDataComponent } from '../rankings/data-widgets/big-number-data.component';
import { SdkViolationRiskComponent } from '../rankings/data-widgets/sdk-violation-risk.component';
import { SdkCodeAnalysisRiskComponent } from '../rankings/data-widgets/sdk-code-analysis-risk.component';
import { ReportConfig } from '../rankings/REPORT_CONFIG';

export const SDK_TYPE_OPTIONS = [
  {
    label: 'All Types',
    value: ''
  },
  {
    label: 'Advertising',
    value: 'Advertising'
  },
  {
    label: 'Analytics',
    value: 'Analytics'
  }
];

export const SDK_RISK_OPTIONS = [
  {
    label: 'All Risk Levels',
    value: ''
  },
  {
    label: 'Critical',
    value: 'C'
  },
  {
    label: 'Not Detected',
    value: 'L'
  }
];

export const DEVICE_OPTIONS = [
  {
    label:
      '<img class="mr-2" src="/assets/images/google-play.svg" alt="Google Play Icon"/> Google Play',
    value: 'android'
  },
  {
    label:
      '<img class="mr-2" src="/assets/images/apple.svg" alt="App Store Icon"/> App Store',
    value: 'ios'
  }
];

export const SDK_REPORT_CONFIG: ReportConfig[] = [
  {
    key: 'sdk-trust-index',
    heading: 'SDK Trust Index',
    subHeading:
      'Independent Risk Rating System for App Developers to Analyze Data Brokers and Advertising SDKs for App Store and FTC Section 5 Compliance Risk',
    title: 'SDK Trust Index',
    pageTitle: 'SDK Trust Index | Pixalate',
    pageMeta: 'Explore Pixalate’s SDK Trust Index',
    reportId: 'sdkTrustIndex',
    sortable: false,
    permissions: [],
    notHideDataIfNA: true,
    mainFilterItems: [
      {
        key: 'appStore',
        algoliaKey: 'appStore',
        label: 'App Store',
        hidden: false,
        type: 'toggle-filter',
        selected: DEVICE_OPTIONS[0],
        options: [...DEVICE_OPTIONS]
      },
      {
        key: 'type',
        label: 'SDK Type',
        hidden: false,
        type: 'dropdown-toggle-filter',
        showCount: true,
        selected: SDK_TYPE_OPTIONS[1],
        options: [...SDK_TYPE_OPTIONS],
        dependencies: [
          {
            key: 'date'
          },
          {
            key: 'appStore'
          }
        ]
      },
      {
        key: 'sdkRisk',
        facetKeys: ['sdkRiskAppStoreRating', 'sdkRiskFtcRating'],
        label: 'SDK Risk',
        hidden: false,
        type: 'dropdown-toggle-filter',
        showCount: true,
        selected: SDK_RISK_OPTIONS[0],
        options: [...SDK_RISK_OPTIONS],
        dependencies: [
          {
            key: 'date'
          },
          {
            key: 'appStore'
          }
        ]
      },
      {
        key: 'date',
        label: 'Month',
        selected: null,
        hidden: false,
        options: [],
        dependencies: [
          {
            key: 'appStore'
          }
        ]
      }
    ],
    gridHeaders: [
      {
        label: 'Rank',
        key: 'rank',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'rank',
        hoverKey: '',
        template: null,
        hidden: false,
        widgetComponent: RankDataComponent,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default:
            'SDK’s ranking sorted by app coverage, split by OS and SDK type'
        }
      },
      {
        label: 'SDK Name',
        key: 'sdkName',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'sdkName',
        hoverKey: '',
        template: null,
        widgetComponent: SdkNameComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent
      },
      {
        label: 'FTC Section 5<br>Violation Risk',
        key: 'sdkRiskFtcRating',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'sdkRiskFtcRating',
        hoverKey: '',
        template: null,
        widgetComponent: SdkViolationRiskComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `An SDK’s risk of violating FTC Section 5, which prohibits "unfair or deceptive acts or practices" via discrepancies between privacy disclosures and SDK code.`
        }
      },
      {
        label: 'App Store ToS<br>Violation Risk',
        key: 'sdkRiskAppStoreRating',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'sdkRiskAppStoreRating',
        hoverKey: '',
        template: null,
        widgetComponent: SdkViolationRiskComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `An SDK’s risk of violating Google Play and Apple App store guidelines via discrepancies between privacy manifest disclosures and SDK code.`
        }
      },
      {
        label: 'Declares Location Collection<br>(Privacy Policy)',
        key: 'locationCollectionDeclared',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'locationCollectionDeclared',
        hoverKey: '',
        template: null,
        widgetComponent: YesnoComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `Whether an SDK’s privacy policy declares the collection of user location information, per Pixalate’s analysis.`
        }
      },
      {
        label: 'Declares Precise Location<br>(Manifest File)',
        key: 'preciseLocationDeclared',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'preciseLocationDeclared',
        hoverKey: '',
        template: null,
        widgetComponent: YesnoComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `Whether an SDK’s privacy manifest file (PrivacyInfo.xcprivacy / AndroidManifest.xml) correctly declares location data collection via device permissions, per Pixalate’s analysis.`
        }
      },
      {
        label: 'Collects Precise Location<br>(Code Analysis)',
        key: 'codeAnalysis',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'codeAnalysis',
        hoverKey: '',
        template: null,
        widgetComponent: SdkCodeAnalysisRiskComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `Whether an SDK’s code base demonstrates the collection of precise location information and if that is data packaged into network-bound payloads that can leave the SDK for potential downstream use and sale.`
        }
      },
      {
        label: 'App<br>Coverage',
        key: 'appCoverage',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'appCoverage',
        hoverKey: '',
        template: null,
        widgetComponent: BigNumberDataComponent,
        format: '0a,text-uppercase',
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `Total number of apps with the SDK installed.`
        }
      },
      {
        label: 'Est. Downloads',
        key: 'estimatedConsumerReach',
        sort: '',
        sortDefault: false,
        sortColumnKey: 'estimatedConsumerReach',
        hoverKey: '',
        template: null,
        widgetComponent: DataOnlyComponent,
        hidden: false,
        headerWidgetComponent: GridHeaderWithTooltipComponent,
        tooltipText: {
          default: `Estimated downloads on apps with the SDK installed, per Pixalate’s analysis.`
        }
      }
    ]
  }
];
